import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { ClinicalSubCategoryService } from "./clicnical-sub-category.service";
import { IClinicalSubCategory } from "./iclinical-sub-category";

@Injectable({
    providedIn: 'root'
})
export class ClinicalSubCategoryResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _subcategoryService: ClinicalSubCategoryService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, clinicalSubCategories: IClinicalSubCategory[] }>> {
        const categoryId = Number(route.paramMap.get('categoryid'));
        var data = {
            categoryId: categoryId,
            pageNumber: 0,
            pageSize: 100,
        };
        return this._subcategoryService.getSubCategory(data);
    }
}